import { stores } from '@kurtosys/app-start';
import { IConfigurationComponentOrchestration } from '@kurtosys/types/app/IConfigurationComponentOrchestration.js';
import { IManifest } from '@kurtosys/types/appsManager/index.js';
import { IExecutionOptions, IQueryOptions } from '@kurtosys/types/query/index.js';
import { computed } from 'mobx';

import { IComponentStyles, IConfiguration, TStoreContext } from '../../../models/index.js';

import { EntityStore } from './EntityStore.js';

export class EntityConsumerStore extends stores.base.StoreBase<IConfiguration, IComponentStyles> {
	entityStore: EntityStore | undefined;
	constructor(storeContext: TStoreContext, manifest: IManifest, entityStore?: EntityStore) {
		super(storeContext, manifest);
		this.entityStore = entityStore;
	}

	async initialize() {
		// Add init logic here
	}

	@computed
	get queryStore() {
		return this.entityStore && this.entityStore.queryStore;
	}

	getQueryValue(
		queryOptions?: IQueryOptions,
		responseForContext?: object,
		overrideExecutionOptions?: Partial<IExecutionOptions>,
	) {
		return super.getQueryValue(queryOptions, responseForContext, overrideExecutionOptions, {
			queryStore: this.queryStore,
		});
	}

	mergeQueriesAndProps<T>(
		componentOrchestration?: IConfigurationComponentOrchestration,
		responseContext?: any,
	): T | undefined {
		return super.mergeQueriesAndProps(componentOrchestration, responseContext, { queryStore: this.queryStore });
	}
}
